import script from "./EurostarTimeLine.vue?vue&type=script&setup=true&lang=ts"
export * from "./EurostarTimeLine.vue?vue&type=script&setup=true&lang=ts"

import "./EurostarTimeLine.vue?vue&type=style&index=0&id=f173e7da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f173e7da"]])

export default __exports__